enum FONTS {
    REGULAR = "Inter-Regular", // 400
    MEDIUM = "Inter-Medium", // 500
    SEMIBOLD = "Inter-SemiBold", // 600
    BOLD = "Inter-Bold", // 700
}

export type FontsType = keyof typeof FONTS;

export default FONTS;
